// extracted by mini-css-extract-plugin
export default {"base":"zdmBr","content":"lzrbH","labelForm":"MWFx6","label":"N0z6t","dataProperties":"yl7Tm"};